import { FILTER_TYPES } from "../../../../../../utils/filter";

const filterConfig = [
  {
    placeholder: "Ingresa el nombre del evento que estas buscando",
    type: FILTER_TYPES.TEXT,
    filterTitle: "Nombre",
    dataField: "name",
  },
];

export default filterConfig;
